/**
 * Chave usada para persistir o contexto de empresa no localStorage.
 */
export const COMPANY_STORAGE_KEY = 'horizon_company_context';

/**
 * Tipagens auxiliares em JSDoc (para editores) — não interferem no build JS.
 *
 * @typedef {Object} Company
 * @property {number} id
 * @property {string} name
 * @property {string} slug
 * @property {string} timezone
 * @property {string} currency
 * @property {string=} logo_url
 * @property {('isp'|'academia'|'empresa'|'ong'|'governo'|'outro')} company_type
 * @property {boolean} is_active
 *
 * @typedef {Object} CompanyContext
 * @property {number[]} ids
 * @property {Company[]} companies
 */

